var _path, _rect, _path2, _path3, _path4, _path5, _path6, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLogoLogin(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 129,
    height: 47,
    viewBox: "0 0 129 47",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M73.4708 14.4927H60.1838V21.8821H73.4708V25.5885H56.1977C55.5139 25.5885 54.9312 25.3476 54.4494 24.8658C53.9832 24.3841 53.7501 23.8091 53.7501 23.1409V13.4204L51.116 10.7863H73.4708V14.4927ZM91.4312 10.7863L99.9395 25.5885H92.7599L91.4312 23.0709H83.4357L82.107 25.5885H74.9273L82.48 12.4646L80.8249 10.7863H91.4312ZM85.0907 19.9007H89.7761L87.6549 15.9146H87.212L85.0907 19.9007ZM123.363 24.3772L120.568 21.5324H121.01C121.679 21.5324 122.254 21.2916 122.735 20.8098C123.217 20.3281 123.458 19.7531 123.458 19.0848V13.2339C123.458 12.5657 123.217 11.9907 122.735 11.5089C122.254 11.0272 121.679 10.7863 121.01 10.7863H99.3083L101.942 13.4204V25.5885H108.376V21.5324H113.644L117.63 25.5885H124.554L128.208 25.5885L123.363 24.3772ZM116.838 14.4927V17.8261H108.376V14.4927H116.838Z",
    fill: "white"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 47.3276,
    y: 21.7034,
    width: 3.88509,
    height: 3.5319,
    fill: "#AAAAAA"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M28.6377 0C27.4184 0 25.2243 4.83512 23.5254 9.96339C22.8328 9.29982 21.9094 8.9314 20.5578 8.92744C18.1309 8.92149 16.3255 10.9181 15.1259 13.3842C14.3583 14.5925 14.092 16.5495 12.0774 19.3167C11.7755 19.7327 11.4559 20.0932 11.1283 20.4121C10.3825 21.145 9.59327 21.6778 8.8494 22.2364C8.79021 22.278 8.72904 22.3216 8.6738 22.3651C9.96816 18.7918 12.8824 13.2436 13.1449 12.5919C13.5217 11.655 12.839 10.1496 9.5538 10.3298C9.5538 10.3298 8.22787 12.8177 6.97889 15.4938C5.21296 18.5739 2.70711 22.1116 0 23.312C0 23.312 1.34961 26.5446 3.16487 24.6846C3.82192 24.0132 4.3586 23.4605 4.81834 22.9732C5.11628 25.7721 7.18804 25.5899 7.95953 25.4195C8.10949 25.3839 8.21012 25.3542 8.23971 25.3443C8.23971 25.3443 8.24168 25.3456 8.24563 25.3482C9.10788 24.7857 9.84188 24.4707 12.2195 22.272C12.4523 22.0601 12.6634 21.8422 12.8548 21.6283C13.0304 21.4322 13.1883 21.2341 13.3363 21.038C13.4468 23.718 14.7865 24.96 16.5169 24.9679C17.1148 24.9679 17.7422 24.5321 18.3716 23.819C19.2359 22.8346 20.0942 21.3173 20.8558 19.7069C20.9722 19.4672 21.0827 19.2216 21.1912 18.978C21.0906 19.6099 21.0551 20.1704 21.0531 20.6379C21.0472 23.304 22.1857 24.8411 23.7385 24.9877C25.1651 25.3007 26.8698 24.6193 28.5726 23.4348L27.7104 22.0522C26.4496 22.8286 25.3722 23.0802 24.7921 22.4206C24.6974 22.3255 24.6126 22.1116 24.6165 21.6402C24.6284 16.9318 29.2218 4.57959 31.8026 2.0006C31.9348 1.86789 32.1321 1.93523 32.1321 1.73517C32.1321 1.40042 30.4195 0.00594205 28.6358 0.00198046L28.6377 0ZM19.5831 18.9998C18.5808 21.0103 17.7087 22.478 17.2509 22.478C17.1345 22.478 17.0497 22.3988 16.9905 22.272C16.8839 22.0423 16.8543 21.656 16.8583 21.3153C16.8642 18.0688 19.958 10.7181 22.0396 10.7894C22.4678 10.7894 22.8289 11.1202 22.9611 11.6847C21.9232 13.9785 20.6762 16.811 19.5851 18.9978L19.5831 18.9998Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M13.6048 0.928976C14.2007 0.334737 17.7641 1.27165 16.9038 2.13132C16.375 2.66019 14.3487 6.76637 14.1829 6.89711C13.7192 7.25959 11.5745 6.6911 11.7106 5.49867C11.9138 3.87442 13.1747 1.35881 13.6048 0.928976Z",
    fill: "#AAAAAA"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "multiply"
    },
    d: "M13.3028 20.0338L12.8529 21.6243C12.6616 21.8383 12.4504 22.0561 12.2176 22.2681C9.84 24.4687 9.10601 24.7837 8.24376 25.3443C8.24376 25.3443 8.24178 25.3429 8.23784 25.3403C8.21021 25.3502 8.10959 25.3819 7.95766 25.4156C7.98331 24.548 8.2556 23.3793 8.67192 22.3632C9.41776 21.8046 10.3826 21.141 11.1265 20.4101L13.3028 20.0318V20.0338Z",
    fill: "url(#paint0_linear_20_151)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "multiply"
    },
    d: "M20.8541 19.7029C20.0925 21.3133 19.2342 22.8306 18.37 23.8151C17.2572 23.3516 17.0342 22.5157 16.9908 22.272C17.05 22.3988 17.1348 22.478 17.2512 22.478C17.711 22.478 18.5811 21.0103 19.5835 18.9998L20.8541 19.7029Z",
    fill: "url(#paint1_linear_20_151)"
  }), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M48.1223 14.0913C47.704 13.8081 46.6227 14.1805 45.2041 14.949C45.0837 15.0065 44.9653 15.0699 44.845 15.1293L44.839 15.1352C43.5999 15.773 42.3648 16.5555 41.2401 17.2883C39.9161 18.15 35.8338 20.4913 31.5107 23.6447L31.483 23.6665C31.4574 23.6863 31.4298 23.7041 31.4041 23.7239C30.9898 23.5853 31.1654 23.0842 31.5778 22.478C32.3039 21.4044 33.7719 20.004 34.056 19.697C37.7556 16.2762 42.0056 12.2056 42.2049 10.8627C42.347 10.0446 40.5692 8.66992 40.0108 8.65011C39.8826 8.64417 38.314 8.86799 36.2225 8.86799C33.9494 8.78282 31.3153 8.21829 30.8497 7.90533C30.7451 7.836 30.7925 7.73498 30.6425 7.76667C30.3367 7.8261 29.8572 8.83036 30.09 10.007C30.2558 10.8567 33.1681 11.5005 36.9722 11.3004C33.1109 14.7371 26.9252 20.9548 26.5799 23.3496C26.4852 23.9894 26.7555 24.6153 27.1244 25.1065C27.5072 25.6176 27.9887 25.984 28.2728 26.0692C28.2886 26.0732 28.3201 26.0732 28.3636 26.0732C28.0518 26.3247 27.7479 26.5822 27.4421 26.8397C27.4421 26.8397 27.4401 26.8411 27.4362 26.8437V26.8477C26.5779 27.5766 25.7452 28.3313 24.956 29.1077C22.3692 31.6412 20.2521 34.3806 19.3543 37.128C18.9084 38.4888 18.7604 39.8516 19.0031 41.1926C20.1357 47.4756 27.965 47.6301 32.1973 45.2512C37.3274 42.3632 40.4844 37.8906 41.3368 34.0954C41.5952 32.9465 41.6426 31.8571 41.465 30.8944C40.5751 26.0118 37.4182 24.6926 36.4691 24.3994C36.4809 24.3935 36.4947 24.3836 36.5066 24.3776C37.578 23.7022 38.7323 23.001 39.999 22.2502C40.7468 21.8303 41.5617 21.3727 42.4003 20.8934C42.4042 20.8934 42.4062 20.8934 42.4062 20.8894C43.6078 20.2041 44.8489 19.4791 46.019 18.768C46.0347 18.7581 46.0466 18.7522 46.0624 18.7422C46.1946 18.661 46.3268 18.5818 46.455 18.5026C47.7 17.8014 48.6609 17.3418 49.4857 17.1834C49.6495 17.1517 49.7619 17.3042 49.8626 17.1556C50.0323 16.9061 49.4541 14.9966 48.1282 14.0913H48.1223ZM37.9805 32.178C37.9805 32.693 37.9233 33.2357 37.7911 33.8042C37.4142 35.4423 36.4296 37.3043 34.4841 39.3683C31.6448 42.385 28.9732 43.6666 26.8896 43.7874C26.8462 43.7914 26.8009 43.7973 26.7574 43.7973C23.6202 43.9102 21.8464 41.3708 22.8645 38.1917C23.8451 35.1373 26.4141 32.174 29.0522 29.8228C29.9578 29.0146 30.8753 28.2798 31.7376 27.636C31.7474 27.6301 31.7573 27.6241 31.7652 27.6142C31.8658 27.539 31.9625 27.4696 32.0612 27.3963C32.2032 27.2914 32.3275 27.1943 32.442 27.1032C32.4479 27.0972 32.4578 27.0933 32.4637 27.0834C32.4913 27.0616 32.5209 27.0358 32.5485 27.014C32.6985 26.9071 32.8504 26.8001 33.0043 26.6912C33.0694 26.6436 33.1405 26.5961 33.2095 26.5466C33.3634 26.4416 33.5213 26.3326 33.6771 26.2237C34.6933 26.4673 35.6384 26.8992 36.2856 27.638C37.14 28.6977 37.9805 30.2328 37.9805 32.18V32.178Z",
    fill: "white"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "multiply"
    },
    d: "M22.8666 38.1897C21.8484 41.3669 23.6203 43.9082 26.7595 43.7953C20.9507 44.2886 19.6385 39.1306 19.3505 37.126C20.2502 34.3806 22.3654 31.6412 24.9521 29.1058L29.0542 29.8189C26.4162 32.1701 23.8492 35.1333 22.8666 38.1877V38.1897Z",
    fill: "url(#paint2_linear_20_151)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "multiply"
    },
    d: "M31.7652 27.6122C31.9507 27.4696 32.1737 27.2973 32.442 27.1012C32.3296 27.1923 32.2033 27.2914 32.0612 27.3944C31.9645 27.4676 31.8659 27.537 31.7652 27.6122Z",
    fill: "url(#paint3_linear_20_151)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "multiply"
    },
    d: "M41.3289 34.0934L37.7931 33.8022C37.9253 33.2337 37.9825 32.691 37.9825 32.176C37.9825 30.2289 37.144 28.6957 36.2876 27.634C35.6405 26.8952 34.6934 26.4634 33.6792 26.2197C33.5213 26.3267 33.3655 26.4376 33.2116 26.5426C34.0383 25.9583 35.1176 25.2293 36.4652 24.3974C37.4143 24.6906 40.5713 26.0098 41.4611 30.8924C41.6367 31.8551 41.5894 32.9445 41.3329 34.0934H41.3289Z",
    fill: "url(#paint4_linear_20_151)"
  }), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M27.7253 22.6682C27.7253 22.6682 27.7159 22.6738 27.7103 22.6776L27.7253 22.6682Z",
    fill: "white"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M31.5776 22.4761C31.1652 23.0822 30.9896 23.5833 31.404 23.722C31.4296 23.7022 31.4572 23.6843 31.4829 23.6645L28.3575 26.0732C28.3141 26.0732 28.2825 26.0732 28.2667 26.0692C27.9846 25.984 27.5031 25.6176 27.1184 25.1065L26.7178 24.4568L31.621 21.6758L31.5776 22.4741V22.4761Z",
    fill: "url(#paint5_linear_20_151)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_20_151",
    x1: 6.94545,
    y1: 24.8609,
    x2: 12.0967,
    y2: 21.2391,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#AEAEAF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.41,
    stopColor: "#C8C8C8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.47,
    stopColor: "#CFCFCF",
    stopOpacity: 0.87
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.66,
    stopColor: "#E3E3E3",
    stopOpacity: 0.5
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.82,
    stopColor: "#F2F2F2",
    stopOpacity: 0.23
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.94,
    stopColor: "#FBFBFB",
    stopOpacity: 0.06
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_20_151",
    x1: 15.7319,
    y1: 24.2885,
    x2: 19.7906,
    y2: 20.713,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#AEAEAF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.41,
    stopColor: "#C8C8C8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.47,
    stopColor: "#CFCFCF",
    stopOpacity: 0.87
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.66,
    stopColor: "#E3E3E3",
    stopOpacity: 0.5
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.82,
    stopColor: "#F2F2F2",
    stopOpacity: 0.23
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.94,
    stopColor: "#FBFBFB",
    stopOpacity: 0.06
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_20_151",
    x1: 22.1799,
    y1: 43.831,
    x2: 24.4159,
    y2: 35.2624,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#AEAEAF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.41,
    stopColor: "#C8C8C8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.47,
    stopColor: "#CFCFCF",
    stopOpacity: 0.87
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.66,
    stopColor: "#E3E3E3",
    stopOpacity: 0.5
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.82,
    stopColor: "#F2F2F2",
    stopOpacity: 0.23
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.94,
    stopColor: "#FBFBFB",
    stopOpacity: 0.06
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_20_151",
    x1: 32.0908,
    y1: 27.3369,
    x2: 32.1007,
    y2: 27.3527,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#AEAEAF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.41,
    stopColor: "#C8C8C8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.47,
    stopColor: "#CFCFCF",
    stopOpacity: 0.87
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.66,
    stopColor: "#E3E3E3",
    stopOpacity: 0.5
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.82,
    stopColor: "#F2F2F2",
    stopOpacity: 0.23
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.94,
    stopColor: "#FBFBFB",
    stopOpacity: 0.06
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_20_151",
    x1: 33.8923,
    y1: 23.2347,
    x2: 37.5776,
    y2: 28.5238,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#AEAEAF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.41,
    stopColor: "#C8C8C8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.47,
    stopColor: "#CFCFCF",
    stopOpacity: 0.87
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.66,
    stopColor: "#E3E3E3",
    stopOpacity: 0.5
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.82,
    stopColor: "#F2F2F2",
    stopOpacity: 0.23
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.94,
    stopColor: "#FBFBFB",
    stopOpacity: 0.06
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_20_151",
    x1: 30.8239,
    y1: 26.6674,
    x2: 29.1975,
    y2: 23.1563,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.33,
    stopColor: "#AEAEAF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.41,
    stopColor: "#C8C8C8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.47,
    stopColor: "#CFCFCF",
    stopOpacity: 0.87
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.66,
    stopColor: "#E3E3E3",
    stopOpacity: 0.5
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.82,
    stopColor: "#F2F2F2",
    stopOpacity: 0.23
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.94,
    stopColor: "#FBFBFB",
    stopOpacity: 0.06
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoLogin);
export default __webpack_public_path__ + "static/media/logo-login.63ea64e1442eea36d2e497577d3dff33.svg";
export { ForwardRef as ReactComponent };